import { deleteOrganisationUser } from '@infuse/api/iam/organisation';
import { deleteTenantUser } from '@infuse/api/iam/tenant';
import { deleteUser } from '@infuse/api/iam/user';
import { UserLevel } from '@infuse/iam/user/type';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { useGenericDeleteUser } from './generic/useGenericDeleteUser';

export const useDeleteUser = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.ORGANISATION) {
    return useGenericDeleteUser({
      apiFn: deleteOrganisationUser,
      forcedParentId: user?.organisationId
    });
  } else if (level === UserLevel.TENANT) {
    return useGenericDeleteUser({
      apiFn: deleteTenantUser,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericDeleteUser({
    apiFn: deleteUser
  });
};
